<mat-form-field class="col-12" subscriptSizing="dynamic">
  <mat-label>
    {{ schema.title }}
    @if (schema.default) {
      <span> (default: {{ schema.default }})</span>
    }
  </mat-label>
  <input matInput [matDatepicker]="picker" [formControl]="aFormControl" />
  <mat-hint>YYYY-MM-DD</mat-hint>
  @if (aFormControl.hasError('matDatepickerParse')) {
    <mat-error>Enter a full date as YYYY-MM-DD, for example 2026-11-03.</mat-error>
  }
  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker [touchUi]="isTouchDevice" #picker></mat-datepicker>
</mat-form-field>
